var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoWorkcenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Name=Sin Centros de trabajo, Shape=-"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 85"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.892 357.194C191.381 353.829 150.545 342.404 121.168 312.853C91.8576 283.37 81.3823 242.436 77.6248 201.012C73.3721 154.129 69.8655 103.901 98.8516 66.8308C130.607 26.2195 181.565 6.88548 232.892 2.44206C289.547 -2.46253 358.573 -4.39963 392.31 41.4261C425.196 86.0958 384.393 145.777 379.08 201.012C374.688 246.674 395.639 299.09 364.306 332.565C332.629 366.408 279.07 360.938 232.892 357.194Z",
    fill: "url(#paint0_linear_2254_99278)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter0_dd_2254_99278)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.637 29C347.225 29 412 127.809 412 230.387C412 307.073 321.836 331 246.637 331C166.942 331 68 311.658 68 230.387C68 124.337 142.645 29 246.637 29Z",
    fill: "url(#paint1_linear_2254_99278)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "remix-icons/outlined/buildings/building-line",
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M299.11 226.667H312.168V240H168.527V226.667H181.586V126.667C181.586 124.899 182.273 123.203 183.498 121.953C184.722 120.702 186.383 120 188.115 120H253.406C255.138 120 256.798 120.702 258.023 121.953C259.247 123.203 259.935 124.899 259.935 126.667V226.667H286.052V173.333H272.993V160H292.581C294.312 160 295.973 160.702 297.198 161.953C298.422 163.203 299.11 164.899 299.11 166.667V226.667ZM194.644 133.333V226.667H246.877V133.333H194.644ZM207.702 173.333H233.819V186.667H207.702V173.333ZM207.702 146.667H233.819V160H207.702V146.667Z",
    fill: "#41435B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2254_99278",
    x: 60,
    y: 25,
    width: 360,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2254_99278"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2254_99278",
    result: "effect2_dropShadow_2254_99278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2254_99278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2254_99278",
    x1: 405,
    y1: 180,
    x2: 74.7932,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13729,
    stopColor: "#5A46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866499,
    stopColor: "#1E95FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2254_99278",
    x1: 68,
    y1: 180,
    x2: 412,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWorkcenters);
export default __webpack_public_path__ + "static/media/noWorkcenters.91d16a559cd7c97db469eb97fd8445be.svg";
export { ForwardRef as ReactComponent };